import axios from 'axios'
import axiosConfig from '../../config/axios.config'
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'

const {apiUrl} = axiosConfig;

// -- fetch uploads
export const fetchUploads = async (instance, email) => {
  try {
    // removed 'axiosConfig.auth' as token is updated on login
    const data = await axios.get(`${apiUrl}/rt/console/getUploads/${instance}/${email}`)
    // console.log('fetchTrial', data)
    return data.data ? data.data : data;
  } catch(err) {
    console.error(err, 'Error occurred fetching trial data.')
    checkResponseErrorCodeAndRedirect(err)
  }
}

// -- download upload
export const downloadUpload = async (id, email) => {
  try {
    // removed 'axiosConfig.auth' as token is updated on login
    const data = await axios.get(`${apiUrl}/rt/console/downloadUpload/${email}/${id}`)
    // console.log('fetchTrial', data)
    return data.data ? data.data : data;
  } catch(err) {
    console.error(err, 'Error occurred fetching trial data.')
    checkResponseErrorCodeAndRedirect(err)
  }
}
